<!-- Display announcements -->
<ng-container *ngIf="userAnnouncements$ | async as announcements">
    <div *ngIf="announcements.length > 0" class="announcements-container">
        <app-announcement-banner
            *ngFor="let announcement of announcements; trackBy: trackByAnnouncementId"
            [message]="getLocalizedMessage(announcement)"
            [linkUrl]="announcement.linkUrl"
            [linkName]="announcement.linkName"
            [dismissible]="announcement.dismissible"
            (dismiss)="onAnnouncementDismiss(announcement.id)"
        ></app-announcement-banner>
    </div>
</ng-container>

<!-- Session Expiration Banner -->
<aum-session-expiration-banner
    [hide]="authWarningIsDismissed"
    [warningThresholdHours]="2"
    (reAuthenticate)="onReAuthenticate()"
    (dismiss)="dismissAuthWarning($event)"
    (idChanged)="onSessionExpirationBannerIdChanged($event)"
></aum-session-expiration-banner>
<router-outlet></router-outlet>
<div [ngClass]="{ displayOverlay: blockingRequestIsActive$ | async }" class="progress-overlay">
    Blocking Request is ongoing
</div>
<aum-notification-toast></aum-notification-toast>
<div id="global-modal-placeholder"></div>
<div id="global-flyout-placeholder"></div>
<div id="global-bottom-placeholder"></div>
